import { PlusSquareOutlined } from "@ant-design/icons";
import React, { useCallback, useMemo, useState } from "react";

interface IAddButton {
  onClick: () => Promise<void>;
}

export const AddButton = React.memo(({ onClick }: IAddButton) => {
  const [inAction, setInAction] = useState<boolean>(false);

  const handleClick = useCallback(async () => {
    if (inAction) {
      return;
    }

    setInAction(true);

    await onClick().finally(() => {
      setInAction(false);
    });
  }, [inAction, onClick]);

  const buttonColor = useMemo(() => (inAction ? "gray" : "black"), [inAction]);

  return (
    <PlusSquareOutlined
      disabled={inAction}
      onClick={inAction ? undefined : handleClick}
      style={{
        width: 24,
        height: 24,
        fontSize: 24,
        color: buttonColor,
        marginBottom: 10,
        float: "left",
      }}
    />
  );
});
